import React, { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAdmin } from "../context/AdminContext";
import { Shield, Eye, EyeOff, ArrowLeft, Loader2 } from "lucide-react";
import { useToast } from "../hooks/use-toast";

const AdminLogin = () => {
  const { login, isAdmin } = useAdmin();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (isAdmin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast({ title: "Welcome back, Super Admin", description: "You are now logged in." });
      navigate("/admin");
    } else {
      setError(res.error);
      toast({
        title: "Login failed",
        description: res.error,
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-slate-50">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-[#16a3a8] mb-4">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <div className="bg-white border border-slate-200 rounded-xl p-8 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-[#16a3a8] flex items-center justify-center text-white">
              <Shield className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-xl font-extrabold text-[#0b1e3f]">Super Admin Login</h1>
              <p className="text-xs text-slate-500">topastrologerinindia.com</p>
            </div>
          </div>

          <form className="mt-6 space-y-4" onSubmit={submit}>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="sachinsharma6886@gmail.com"
                className="w-full px-3 py-2 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#16a3a8]/30 focus:border-[#16a3a8] text-sm"
                autoComplete="email"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1">Password</label>
              <div className="relative">
                <input
                  type={showPass ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full px-3 py-2 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#16a3a8]/30 focus:border-[#16a3a8] text-sm pr-10"
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500"
                >
                  {showPass ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="btn-cta w-full py-2.5 rounded-md text-sm uppercase disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              {loading ? "Signing in..." : "Login"}
            </button>
          </form>

          <p className="text-[11px] text-slate-500 mt-6 text-center">
            Restricted area. Only the super admin can access this dashboard.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
